/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ThreeDots/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ThreeDots({
  children,
  viewPath = "/DesignSystem/Svgs/ThreeDots",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="ThreeDots.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-w6gig': alignSelf,'--mt-2-w6gig': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-w6gig': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-w6gig': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-w6gig': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-w6gig': opacity,'--w-7-w6gig': typeof width === 'number' ? `${width}px` : width,'--h-8-w6gig': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<circle
  data-testid="ThreeDots.SvgCircle"
  data-view-path={viewPath}
 cx={16}
 cy={16}
 r={2.6}
 style={{'--f-9-w6gig': fill}}
 className={`views-block ${styles.SvgCircle}`}
/>
<circle
  data-testid="ThreeDots.SvgCircle:1"
  data-view-path={viewPath}
 cx={16}
 cy={25.1}
 r={2.6}
 style={{'--f-9-w6gig': fill}}
 className={`views-block ${styles.SvgCircle1}`}
/>
<circle
  data-testid="ThreeDots.SvgCircle:2"
  data-view-path={viewPath}
 cx={16}
 cy={6.9}
 r={2.6}
 style={{'--f-9-w6gig': fill}}
 className={`views-block ${styles.SvgCircle2}`}
/>
</svg>
{children}
</React.Fragment>)
}